import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.172 7.858a5.598 5.598 0 1 0-10.344 4.284 5.598 5.598 0 0 0 10.344-4.284m-7.85-4.324a6.998 6.998 0 1 1 5.356 12.932A6.998 6.998 0 0 1 7.322 3.534",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.643 6.75c.285.01.536.19.636.458l1.299 3.482.439-.98a.7.7 0 0 1 .64-.417h1.14c.388 0 .703.317.703.707s-.315.707-.703.707h-.684l-.953 2.126a.703.703 0 0 1-1.3-.041L9.561 9.31l-.439.98a.7.7 0 0 1-.64.417h-2.28A.705.705 0 0 1 5.5 10c0-.39.315-.707.703-.707h1.824l.952-2.126a.7.7 0 0 1 .664-.417",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=ActivityIcon20.js.map